import type { ReactElement, SVGProps } from "react";

export function PercentageWhiteCircleIcon(
  props: SVGProps<SVGSVGElement>,
): ReactElement {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_120_9095)">
        <path
          d="M10.5513 3.00594L12.7212 3.48933L12.4995 5.72078L13.9712 7.38484L12.4995 9.0489L12.7212 11.2803L10.5513 11.7637L9.43213 13.6807L7.38428 12.8145L5.33643 13.6807L4.21729 11.7637L2.04736 11.2803L2.26904 9.0489L0.797363 7.38484L2.26904 5.72078L2.04736 3.48933L4.21729 3.00594L5.33643 1.08894L7.38428 1.95515L9.43213 1.08894L10.5513 3.00594ZM8.98877 8.00008C8.71433 8.00018 8.48087 8.0961 8.28857 8.28816C8.09622 8.48041 8.00055 8.71391 8.00049 8.98836C8.00049 9.26302 8.09637 9.49712 8.28857 9.68953C8.48083 9.88175 8.71434 9.97762 8.98877 9.97762C9.26331 9.97758 9.49662 9.88161 9.68896 9.68953C9.88135 9.49725 9.978 9.26385 9.97803 8.98933C9.97803 8.71467 9.88215 8.48057 9.68994 8.28816C9.49764 8.09577 9.26332 8.00008 8.98877 8.00008ZM4.92725 9.01961L5.88135 9.97371L9.97412 5.88094L9.02002 4.92683L4.92725 9.01961ZM5.9126 4.92293C5.63796 4.92293 5.40383 5.01884 5.21143 5.21101C5.01913 5.40321 4.92345 5.63685 4.92334 5.91121C4.92334 6.18588 5.01922 6.41997 5.21143 6.61238C5.40371 6.80474 5.63712 6.90045 5.91162 6.90047C6.18629 6.90047 6.42038 6.80459 6.61279 6.61238C6.80496 6.42014 6.90088 6.18658 6.90088 5.91219C6.90085 5.63769 6.80481 5.40433 6.61279 5.21199C6.42055 5.01965 6.18704 4.923 5.9126 4.92293Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_120_9095">
          <rect width="14.7692" height="14.7692" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
